<template>
  <div class="ability flex">
    <div v-if="$props.ability.title" class="ability-title text-center">
      <h2 class="ability-title-tag">{{ $props.ability.title }}</h2>
    </div>
    <div
      v-for="(stockElement, i) in $props.ability.stock"
      :key="`stockElement-${i}`"
      :class="['ability-data flex', { 'no-first': i > 0 }]"
    >
      <div v-if="stockElement.logotype" class="ability-data-image flex">
        <div
          :class="[
            'ability-data-image-container flex',
            { [stockElement.backgroundColor]: stockElement.backgroundColor }
          ]"
        >
          <img
            :src="stockElement.logotype"
            :alt="$t('aboutMe.altLabel', { element: stockElement.name })"
            class="ability-data-image-container-tag"
          />
        </div>
      </div>
      <div class="ability-data-content text-center text-md-left">
        <div v-if="stockElement.name" class="ability-data-content-text">
          <h3 class="ability-data-content-text-tag">
            <b>{{ stockElement.name }}</b>
          </h3>
        </div>
        <div v-if="stockElement.lastTimeUsed" class="ability-data-content-text">
          <h3 class="ability-data-content-text-tag">
            {{ $t("aboutMe.abilities.lastTimeUsedLabel") }} <b>{{ stockElement.lastTimeUsed }}</b>
          </h3>
        </div>
        <div v-if="stockElement.timeUsed" class="ability-data-content-text">
          <h3 class="ability-data-content-text-tag">
            {{ $t("aboutMe.abilities.timeUsedLabel") }} <b>{{ stockElement.timeUsed }}</b>
          </h3>
        </div>
        <div v-if="stockElement.level" class="ability-data-content-text">
          <h3 class="ability-data-content-text-tag">
            {{ $t("aboutMe.abilities.levelLabel") }} <b>{{ stockElement.level }}</b>
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Ability",
  props: {
    /*
     * @property - ability
     * Defines all content inside this component
     * $ability.title

     * $ability.school
     * $ability.href
     * $ability.logotype
     * $ability.backgroundColor
     * $ability.date
     * $ability.grade
     */
    ability: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.ability {
  border-top: 0.0625rem solid $main-green;
  flex-wrap: wrap;
  padding: 1.5rem 0 3rem 0;

  &-title {
    flex: 1 0 100%;

    &-tag {
      margin-bottom: 0;
    }
  }

  &-data {
    flex: 1 0 100%;
    flex-wrap: inherit;
    margin-top: 1.5rem;

    @include breakpoint($large) {
      flex: 1 0 50%;
    }

    @include breakpoint($xxlarge) {
      flex: 1 0 33.3333%;
    }

    @include breakpoint($xxxlarge) {
      flex: 1 0 25%;
    }

    &-image {
      width: 100%;

      @include breakpoint($medium) {
        flex: 0 0;
      }

      &-container {
        @include boxShadow(0.25, true, false);
        background-color: $white-raw;
        border: 0.0625rem solid $main-blue;
        border-radius: 0.45rem;
        height: 6.5rem;
        margin: auto;
        overflow: hidden;
        width: 6.5rem;

        &.black {
          background-color: $dark-gray;
          border: 0.0625rem solid $main-green;
        }

        &-tag {
          border-radius: 0.25rem;
          margin: auto;
          max-height: 95%;
          max-width: 95%;
        }
      }
    }

    &-content {
      padding: 0 0.5rem;
      width: 100%;

      @include breakpoint($medium) {
        flex: 1 0;
        max-width: 100%;
        padding-left: 1rem;
      }

      &-text {
        width: 100%;

        &-tag {
          display: inline-block;
          margin: 0.75rem 0 0.25rem 0;

          @include breakpoint($medium) {
            margin: 0.85rem 0 0 0;
          }
        }
      }
    }
  }
}
</style>
